import { Input } from '@angular/core';
import { EventEmitter, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';

@Component({
  selector: 'app-sessionout',
  templateUrl: './sessionout.component.html',
  styleUrls: ['./sessionout.component.css']
})
export class SessionoutComponent implements OnInit {

  @Input() sessiontime: number = 0;
  
  interval;

  
  @Output() emitData = new EventEmitter();

  
  constructor( private appService: LoginserviceService,private route: ActivatedRoute, private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  startTimer() {
    this.interval = setInterval(() => {
      if(this.sessiontime > 0) {
        this.sessiontime--;
      } else {
        this.sessiontime = 30;
      }
    },1000)
  }

  fnLogout() {
    clearInterval(this.interval);

    // sessionStorage.removeItem("hrtoken");
        
    // this.appService.fnCheckLogin();

    this.activeModal.close(false);

  }

  public decline() {
    this.activeModal.close(false);
  }


}
